const SelectionCell = ({ form, selectedForm, onFormClick, readonly }) => {
    if (readonly) return null

    return (
        <div className="tw:flex tw:justify-center tw:pl-4">
            <input
                type="radio"
                className="custom-radio"
                checked={selectedForm?.id === form.id}
                onChange={() => onFormClick(form)}
            />
        </div>
    )
}

export default SelectionCell
